import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Text } from "./Text";
export const Notice = (p)=>/*#__PURE__*/ _jsxs("div", {
        className: "block block--notice",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "title--m",
                children: p.title
            }),
            /*#__PURE__*/ _jsx(Text, {
                ...p.description
            })
        ]
    });
